import React from 'react'
import AutoSwipeBanner from './AutoSwipeBanner'

const Banner = () => {

    return (
        <section className="header-banner w-full bg-yellow-50 min-h-[200px] sm:min-h-[240px] md:min-h-[520px] lg:min-h-[600px] xl:min-h-[680px] flex flex-col justify-center py-2 sm:py-3 md:py-5 lg:py-8 pt-8 sm:pt-14 md:pt-16 lg:pt-20 xl:pt-8">
            {/* Auto Swipe Banner */}
            <div className="w-full flex justify-center items-center mb-1 sm:mb-2 md:mb-4    px-2 sm:px-3 md:px-4">
                <AutoSwipeBanner />
            </div>
            
        </section>
    )
}

export default Banner
